<template>
  <div class="zener-diode-viz">
    
    <div class="viz-header" >
      <div class="brief" v-latex="knowledgePoint"></div>
      <div class="formula" v-latex>$<strong>公式：</strong>U_z = const | 稳压原理$</div>
    </div>

    <div class="main-layout vertical">
      <div class="canvas-box simulation">
        <svg width="100%" height="240" viewBox="0 0 400 240">
          <!-- The Circuit -->
          <line x1="50" y1="120" x2="350" y2="120" stroke="#888" stroke-width="2" />
          
          <!-- Power Supply -->
          <g transform="translate(50, 100)">
             <rect width="20" height="40" fill="#222" stroke="#ffd700" />
             <text x="-10" y="55" fill="#ffd700" font-size="8">Vin: {{ vin }}V</text>
          </g>

          <!-- The Zener Symbol -->
          <g transform="translate(200, 120)">
             <line x1="-20" y1="-20" x2="-20" y2="20" stroke="#ff4757" stroke-width="3" />
             <path d="M -20,0 L 10,-15 L 10,15 Z" fill="#ff4757" />
             <path d="M 10,-20 L 10,20 L 15,25 M 5,15 L 10,20" fill="none" stroke="#ff4757" stroke-width="2" />
             <text x="-25" y="-30" fill="#ff4757" font-size="10">Vz = 5.1V</text>
          </g>

          <!-- Current flow (Dots) -->
          <g v-if="vin > 0">
             <circle v-for="n in 5" :key="n" r="2" fill="#ffd700">
                <animate attributeName="cx" :from="50" :to="350" :dur="`${Math.max(0.1, 2/vin)}s`" repeatCount="indefinite" />
                <animate attributeName="cy" values="120" dur="1s" repeatCount="indefinite" />
             </circle>
          </g>

          <!-- Load Indicator (Light) -->
          <circle cx="350" cy="120" r="15" :fill="loadColor" opacity="0.8" />
          <text x="335" y="150" fill="#888" font-size="8">负载 RL</text>
          <text x="335" y="100" fill="#fff" font-size="10">{{ vout.toFixed(1) }} V</text>
        </svg>

        <div class="hud-top">
           <div class="stat">
              <label>状态: {{ vin > 5.1 ? '齐纳击穿 (稳压中)' : '截止状态' }}</label>
           </div>
        </div>
      </div>

      <div class="bottom-controls">
        <div class="control-card glass">
          <div class="row items-center">
             <label>调节输入电压 Vin</label>
             <el-slider v-model="vin" :min="0" :max="12" :step="0.1" size="mini"></el-slider>
          </div>
        </div>

        <div class="discovery-note" v-latex>
           <p><strong>物理详解：</strong>齐纳二极管是一种特殊的半导体器件，它利用了**齐纳击穿**（量子隧穿）或雪崩击穿效应。当反向电压达到临界值 Vz 时，电流会急剧增加，但管子两端的电压却几乎保持恒定。这使得它成为电路中的“电压锚点”，能将不稳定的波动电压过滤为纯净的直流电，保护昂贵的芯片不受过压损坏。</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ZenerDiodeViz',
  props: { knowledgePoint: { type: String, default: '' } },
  data() {
    return {
      vin: 3.5
    }
  },
  computed: {
    vout() {
       return this.vin > 5.1 ? 5.1 : this.vin;
    },
    loadColor() {
       let intensity = this.vout / 5.1;
       return `rgba(255, 215, 0, ${intensity})`;
    }
  }
}
</script>

<style scoped lang="scss">
.zener-diode-viz { flex: 1; display: flex; flex-direction: column; gap: 12px; height: 100%; overflow: hidden; }
.canvas-box { background: #020205; border-radius: 12px; position: relative; border: 1px solid rgba(255,255,255,0.05); }
.bottom-controls { flex: 0.6; display: flex; flex-direction: column; gap: 10px; }
.control-card { background: rgba(255,255,255,0.03); border-radius: 12px; padding: 15px; }
.discovery-note { background: rgba(255, 71, 87, 0.05); padding: 12px 18px; border-radius: 12px; p { margin: 0; font-size: 0.75rem; color: #aaa; line-height: 1.5; strong { color: #fff; } } }
</style>
